import { Card, CardContent, Grid, Typography } from "@mui/material";
import { IOrderShipmentUnitsDescription } from "../../interfaces/order";
import OrderShipmentUnitsContent from "./OrderShipmentUnitsContent";

const OrderShipmentUnitsDescription = ({
  shipmentUnits,
  isMobile,
}: IOrderShipmentUnitsDescription) => (
  <Grid item xs={12} mt={3.75}>
    <Typography className="f-s-20 text-dark m-b-20">
      Agrupación inteligente para ahorro de costos
    </Typography>
    {isMobile ? (
      <OrderShipmentUnitsContent shipmentUnits={shipmentUnits.filter((item) => item.used_virtual_box_id)} />
    ) : (
      <Card className="br-20 bg-light">
        <CardContent sx={{ padding: "20px" }}>
          <OrderShipmentUnitsContent shipmentUnits={shipmentUnits.filter((item) => item.used_virtual_box_id)} />
        </CardContent>
      </Card>
    )}
  </Grid>
);

export default OrderShipmentUnitsDescription;
